import React from 'react';
import statusTypes from '../../status-types';

const colorMap = {};

statusTypes.forEach(el => {
	colorMap[el.code] = el.color;
});

function pinSymbol(color) {
    return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#333',
        strokeWeight: 1,
        scale: 1,
   };
}

class ListMap extends React.Component {
    map;
    infowindow;
    markers;

	constructor(props) {
		super(props);

        this.map = null;
        this.infowindow = null;
        this.markers = [];
	}

	componentDidMount() {
		this.map = new google.maps.Map(this.refs.map, {
			zoom: this.props.zoom,
			center: new google.maps.LatLng(this.props.latitude, this.props.longitude),
			mapTypeId: this.props.mapTypeId === 'satellite' ? google.maps.MapTypeId.SATELLITE : google.maps.MapTypeId.ROADMAP,
		});
		this.setMarkers(this.props.listings);
	}

	setMarkers(listings) {
		if (listings) {
			this.clearMarkers();
			this.markers = listings.filter(el => el.LATITUDE && el.LONGITUDE).map(el => {
				const infowindow = new google.maps.InfoWindow({
					content: `<a href='https://strivere.com/property/${el.ARCIMEDES_ROW_ID}' target='_blank' style='display: block; color: inherit;'>
						<div>
							<div><strong>${el.NAME}</strong></div>
							<div>${el.ADDRESS}</div>
							<div>${el.CITY}, ${el.STATE} ${el.ZIP}</div>
						</div>
					</a>`
				});

				const marker = new google.maps.Marker({
					position: {lat: parseFloat(el.LATITUDE), lng: parseFloat(el.LONGITUDE)},
					map: this.map,
					icon: pinSymbol(colorMap[el.STATUS] || '#F00'),
				});

				marker.addListener('click', ()=> {
					if (this.infowindow) {
						this.infowindow.close();
					}
					this.infowindow = infowindow;
					infowindow.open(this.map, marker);
				});

				return marker;
			});
		}
	}

	clearMarkers() {
		this.markers.forEach(el => el.setMap(null));
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.listings !== this.props.listings) {
			this.setMarkers(nextProps.listings);
		}
	}

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return (
			<div ref='map' className='ListMap'/>
		);
	}
}

ListMap.defaultProps = {
    latitude: 32.7801399,
    longitude: -96.80045109999998,
    zoom: 4,
};

export default ListMap;